module.exports = __webpack_public_path__ + "static/media/new-News.e3711ba6.jpg";